export const ADD_TO_CART = "cart/add_to_cart";
export const INCREMENT_ITEM = "cart/increment_item";
export const DECREMENT_ITEM = "cart/decrement_item";


